import React from 'react';
import './AboutUs.css';
import shivneri from './shivneri.png';

const AboutUs = () => {
  return (
    <>
      {/* ================= ABOUT SECTION ================= */}
      <section className="about-section">
        {/* Background Shapes */}
        <div className="background-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
        </div>

        {/* Content Container */}
        <div className="about-container">
          <div className="about-content">
            {/* Text Content */}
            <div className="text-section">
              <h2 className="section-titles">About Shivneri Fresh</h2>
              <p className="section-description">
                Shivneri Fresh is your trusted local retail store, committed to bringing the finest, freshest produce and grocery items to your doorstep. We pride ourselves on quality, sustainability, and community connection. Established in September 2023, Shivneri Fresh is an Indian grocery shop in Vashi, Navi Mumbai. They offer a carefully chosen selection of high-quality ingredients, perfect for those seeking to elevate their home cooking.
              </p>

              {/* Feature Highlights */}
              <div className="feature-grid">
                <div className="feature-card">
                  <i className="icon icon-leaf"></i>
                  <span>Fresh Produce</span>
                </div>
                <div className="feature-card">
                  <span>Quality Groceries</span>
                </div>
                <div className="feature-card">
                  <i className="icon icon-truck"></i>
                  <span>Fast Delivery</span>
                </div>
              </div>
            </div>

            {/* Image Section */}
            <div className="image-section">
              <div className="image-wrapper">
                <img src="./about1.jpg" alt="Shivnari Fresh Store" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= OUR VALUES SECTION ================= */}
      <section className="ourValuesSection">
        <div className="ourValuesContent">
          <div className="image-wrappers">
            <img src="./aboutf.webp" alt="Shivnari Fresh Store" />
          </div>
          <div className="ourValues">
            <h3 className="upper">Our Values</h3>
            <p>
              At Shivneri Fresh, we are committed to providing fresh, high-quality groceries while keeping our customers’ needs at the heart of everything we do. We believe in supporting our local community by sourcing from trusted local farmers and producers, ensuring both quality and sustainability. Our team is dedicated to creating a friendly, welcoming shopping experience, and we strive to offer products that are both affordable and reliable. Integrity, transparency, and care guide every decision we make, because we want every visit to our store to be one you can trust.
            </p>
            <div>
              <div className="feature-card2">
                <i className="icon icon-leaf"></i>
                <span>Fresh Produce</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= WHAT WE OFFER SECTION ================= */}
      <section className='offer'>
        <div className="whatWeOffer">
          <div className="ourValuesContent">
            <div className="ourValues">
              <h3 className="upper">What We Offer</h3>
              <p>
                At Shivneri Fresh, we are committed to providing fresh, high-quality groceries while keeping our customers’ needs at the heart of everything we do. We believe in supporting our local community by sourcing from trusted local farmers and producers, ensuring both quality and sustainability. Our team is dedicated to creating a friendly, welcoming shopping experience, and we strive to offer products that are both affordable and reliable. Integrity, transparency, and care guide every decision we make, because we want every visit to our store to be one you can trust.
              </p>
              <div>
                <div className="feature-grid2">
                  <div className="feature-card3">
                    <span>Fresh Produce</span>
                  </div>
                  <div className="feature-card3">
                    <span>Quality Groceries</span>
                  </div>
                  <div className="feature-card3">
                    <span>Fast Delivery</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="image-wrappers1">
              <img src="./about3.jpg" alt="Shivnari Fresh Store" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs;
